import { DateRange, DateRangePreset } from "./types";

export const PRESETS: { id: DateRangePreset; label: string }[] = [
  { id: "all", label: "Cijeli period" },
  { id: "currentMonth", label: "Trenutni mjesec" },
  { id: "currentYear", label: "Trenutna godina" },
  { id: "last30", label: "30 dana" },
  { id: "last3m", label: "3 mjeseca" },
  { id: "last6m", label: "6 mjeseci" },
  { id: "last12m", label: "12 mjeseci" },
];

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const endOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);

/** Izračuna { from, to } za dani preset u odnosu na `now`. "all" -> { null, null }. */
export const resolvePreset = (
  preset: DateRangePreset,
  now: Date = new Date()
): { from: Date | null; to: Date | null } => {
  const to = endOfDay(now);
  switch (preset) {
    case "all":
      return { from: null, to: null };
    case "currentMonth":
      return { from: new Date(now.getFullYear(), now.getMonth(), 1), to };
    case "currentYear":
      return { from: new Date(now.getFullYear(), 0, 1), to };
    case "last30":
      return { from: startOfDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29)), to };
    case "last3m":
      return { from: startOfDay(new Date(now.getFullYear(), now.getMonth() - 3, now.getDate())), to };
    case "last6m":
      return { from: startOfDay(new Date(now.getFullYear(), now.getMonth() - 6, now.getDate())), to };
    case "last12m":
      return { from: startOfDay(new Date(now.getFullYear(), now.getMonth() - 12, now.getDate())), to };
    default:
      return { from: null, to: null };
  }
};

export const DEFAULT_PRESET: DateRangePreset = "last3m";

export const buildRangeFromPreset = (preset: DateRangePreset, now?: Date): DateRange => ({
  ...resolvePreset(preset, now),
  preset,
});

export const rangeLabel = (range: DateRange): string => {
  if (range.preset !== "custom") {
    return PRESETS.find((p) => p.id === range.preset)?.label ?? "Razdoblje";
  }
  const fmt = (d: Date | null) =>
    d
      ? `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}.`
      : "…";
  return `${fmt(range.from)} – ${fmt(range.to)}`;
};
